module.exports = __webpack_public_path__ + "static/media/logo-ball.bf264267.svg";